$(document).on("click",".variant-swatches .swatch",function(){

$(this).parents(".variant-swatches").find(".swatch").removeClass('selected');
    $(this).addClass('selected');
    
});
        $(document).on("click","#CartDrawer-Overlay",function(event) {
 const cartOverlay = document.getElementById('CartDrawer-Overlay');

    if (cartOverlay && cartOverlay.contains(event.target)) {
     $("button.drawer__close").trigger('click');
    }
  });
 document.addEventListener("DOMContentLoaded", function() {

 var windowWidth = window.innerWidth;
 if (windowWidth <= 750) {   
 const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
  const items = document.querySelectorAll('.js-acc-item');
  const thisItem = this.parentNode;

  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('is-open');
      return;
    }
    item.classList.remove('is-open');
  });
} 
 }
   // main slider arrows text
   const prevButton = document.querySelector('.slider-button--prev');
    const nextButton = document.querySelector('.slider-button--next');
    const dots = document.querySelectorAll('.slider-counter__link--dots');
    const slides = document.querySelectorAll('.slideshow__slide');
    const leftContent = document.querySelector('.left_content');
    const rightContent = document.querySelector('.right_content');
    const totalSlides = slides.length;
    let currentSlideIndex = 0;

    function updateSlideHeadings() {
      const currentSlide = slides[currentSlideIndex];
      const prevSlide = slides[(currentSlideIndex - 1 + totalSlides) % totalSlides];
      const nextSlide = slides[(currentSlideIndex + 1) % totalSlides];

if (prevSlide && prevSlide.querySelector('.banner__heading')) {
  const prevHeading = prevSlide.querySelector('.banner__heading').textContent;
  leftContent.textContent = prevHeading;
}

if (nextSlide && nextSlide.querySelector('.banner__heading')) {
  const nextHeading = nextSlide.querySelector('.banner__heading').textContent;
  rightContent.textContent = nextHeading;
}
    }
if(prevButton){
    prevButton.addEventListener('click', function() {
      if (currentSlideIndex > 0) {
        currentSlideIndex--;
      } else {
        currentSlideIndex = totalSlides - 1;
      }
      updateSlideHeadings();
    });
  }
  if(nextButton){
    nextButton.addEventListener('click', function() {
      if (currentSlideIndex < totalSlides - 1) {
        currentSlideIndex++;
      } else {
        currentSlideIndex = 0;
      }
      updateSlideHeadings();
    });
  }


    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        currentSlideIndex = index;
        updateSlideHeadings();
      });
    });

    // Initialize with the first slide's headings
    updateSlideHeadings();



});

// search placement 
   document.getElementById("custom_search").addEventListener("click", function() {
    // Target the element you want to add the attribute to
    var targetElement = document.getElementById("main_search_wrap");
     var addclassElement =  document.querySelector(".header__inline-menu ul");
    // Add the attribute to the target element
    targetElement.setAttribute("open", "true");
     addclassElement.classList.add("search_opened");
    const searchInput = document.querySelector(".search__input");
    searchInput.focus(); // Focus on the input field
    searchInput.select(); // Optionally select the text inside the input
});
document.querySelector(".search-modal__close-button").addEventListener("click", function() {
    var targetElement = document.querySelector(".header__inline-menu ul");
    // Check if element with class exists
    if (targetElement) {
        // Remove a class from the selected element
        targetElement.classList.remove("search_opened");
   //    location.reload();
    } 
  /* Refersh Search Bar */
 $('.reset__button').trigger('click');
   
});


/*------------ 
      document.addEventListener("DOMContentLoaded", () => {
      const closeButton = document.querySelector(".search-modal__close-button");
      closeButton.addEventListener("click", () => {
      setTimeout(function() {
      var url = window.location.href; // Get the URL from the clicked element
      $(".header__search").load(url + " .header__search > *");
      console.log("updated url"+url);
      }, 800); 
      });
      });
/*------------*/ 

// collection custom variants 
document.addEventListener('DOMContentLoaded', function () {
  const swatches = document.querySelectorAll('.swatch');
  const firstAvailableSwatch = document.querySelector('.swatch.selected');
  
  // Check if the element exists
  if (firstAvailableSwatch) {
    const parentListItemfirst = firstAvailableSwatch.closest('.collection_grid');
    const firstAvailableImageSrc = firstAvailableSwatch.getAttribute('var_img');
    const firstAvailablePrice = firstAvailableSwatch.getAttribute('var_price');
    
    if (parentListItemfirst) {
      const productImage = parentListItemfirst.querySelector('.main-card-image');
      const productPrice = parentListItemfirst.querySelector('.var_price');
      
      if (firstAvailableImageSrc) {
        productImage.src = firstAvailableImageSrc;
        productImage.srcset = firstAvailableImageSrc;
      }
      
      if (firstAvailablePrice) {
        productPrice.textContent = firstAvailablePrice;
      }
    }
  }
  
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
    const variantId = this.getAttribute('data-variant-id');
    const variantImg = this.getAttribute('var_img');
    const variantPrice = this.getAttribute('var_price');    
    const parentListItem = this.closest('.collection_grid');
    const variantQty =   this.getAttribute('data-var-value');
    const  variantUrl =   this.getAttribute('data-var-url');
    const  soldOutText =   this.getAttribute('sold-out-text');
 // Find the container for the button and newHtml
    const container = this.closest('.card__content').querySelector('.quick-add');
    
    // Define new HTML
    const newHtml = `
        <span class="learn-more-atc" style="display: none;">
            <a href="${variantUrl}">
                ${soldOutText}
                <img src="https://cdn.shopify.com/s/files/1/0285/4436/8743/files/Arrow-black_38e8ca31-c6a7-48ec-9d99-9067e36c3db0.svg?v=1721899378" class="arrow_icon">
            </a>
        </span>
    `;
    
    // Create a new span element for newHtml and append it to the container if it doesn't already exist
    let newHtmlElement = container.querySelector('.learn-more-atc');
    const atcElement = container.querySelector('.atc.default-learnmore');
    if (atcElement) {
    atcElement.style.display = 'none';
    }
    if (!newHtmlElement) {
        container.innerHTML += newHtml;
        newHtmlElement = container.querySelector('.learn-more-atc');
      
    }
    
    if (variantQty === '0') {
     
     // Find and hide the button
        const button = container.querySelector('button');
        if (button) {
            button.style.display = 'none';
        }
    
        // Show the newHtml
        newHtmlElement.style.display = 'inline'; // or 'block' depending on your layout
    } else {
        // Show the button and hide newHtml
        const button = container.querySelector('button');
        if (button) {
            button.style.display = 'inline'; // or 'block' depending on your layout
        }
    
        // Hide the newHtml
        if (newHtmlElement) {
            newHtmlElement.style.display = 'none';
        }
    }


      if (parentListItem) {
        const productImage = parentListItem.querySelector('.main-card-image');
        const productPrice = parentListItem.querySelector('.var_price');
        const swatchesInGrid = parentListItem.querySelectorAll('.swatch');
    
        swatchesInGrid.forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');
        
        if (variantPrice) {
          productPrice.textContent = variantPrice;
        }
        
        if (variantImg) {
          productImage.src = variantImg;
          productImage.srcset = variantImg;
        }
        
        const productForm = parentListItem.querySelector('form');
        const variantInput = productForm.querySelector('.product-variant-id');
        variantInput.value = variantId;
        if (productForm) {
          // const variantInput = productForm.querySelector('.product-variant-id');
          // const parentButton = productForm.querySelector('.quick-add__submit');
          // const addToCartButton = productForm.querySelector('.atc');
          // const soldButton = productForm.querySelector('.sold-out-message');
         
          // if (this.classList.contains('soldvar')) {
          //    soldButton.classList.remove('hidden');
          //   addToCartButton.classList.add('hidden');
          //   parentButton.classList.add('soldout');
          //   parentButton.setAttribute('disabled', 'disabled');
          // } else {
          //    soldButton.classList.add('hidden');
          //   addToCartButton.classList.remove('hidden');
          //   parentButton.classList.remove('soldout');
          //   parentButton.removeAttribute('disabled', 'disabled');
          // }
          
          // if (variantInput) {
          //   variantInput.value = variantId;
          // }
        }
      }
    });
  });
});

function togglePasswordVisibility() {
  const passwordField = document.getElementById('CustomerPassword');
  const eyeIcon = document.getElementById('eye-icon');
  
  if (passwordField.type === 'password') {
    passwordField.type = 'text';
    eyeIcon.innerHTML = `
      <path d="M17.94 17.94A10.05 10.05 0 0 1 12 20c-4.9 0-8.64-2.94-10-8 1.36-5.06 5.1-8 10-8 1.69 0 3.26.38 4.66 1.05m2.42 2.42A9.96 9.96 0 0 1 22 12c-1.36 5.06-5.1 8-10 8a9.96 9.96 0 0 1-4.66-1.05M2 2l20 20"></path>`;
  } else {
    passwordField.type = 'password';
    eyeIcon.innerHTML = `       
      <path d="M1 12S4 4 12 4s11 8 11 8-3 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>`;
  }
}

// customer account edits

function opentab(tabName,index) {
  var i;
  var x = document.getElementsByClassName("my-tabs");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";  
  }
  var indexs = parseInt(index);
  document.getElementById(tabName).style.display = "block";  
   var y = document.getElementsByClassName("my-bar-item");
	for (i = 0; i < y.length; i++) {
	   var clsname = y[i].classList.value;
	   var result = clsname.includes("active-tab");
	   if(result == true ){
	     y[i].classList.remove("active-tab");
	   }
	}
    y[indexs].classList.add("active-tab");
}


document.addEventListener("click", function(event) {
    if (event.target.closest(".edit-per")) {
      var updatedElement = document.querySelector(".address-updated.pre-c");
      if (updatedElement) updatedElement.style.display = "none";
        const inputs = document.querySelectorAll(".personal-info-edit input");
        inputs.forEach(input => input.disabled = false);

        document.querySelector(".edit-form-btns").style.display = "none";
        document.querySelector(".save-btns").style.display = "block";
    }
  if (event.target.closest(".edit-cancel")) {
        const inputs = document.querySelectorAll(".personal-info-edit input");
        inputs.forEach(input => input.disabled = true);

        document.querySelector(".save-btns").style.display = "none";
        document.querySelector(".edit-form-btns").style.display = "block";
    }
});
/* Account Update js */
document.addEventListener("DOMContentLoaded", function() {
 const phoneNumberInput = document.querySelector(".personal-info-edit .phn");
const phoneError = document.getElementById("phone-error");
const emailError = document.getElementById("email-address-error");

if (phoneNumberInput) {
  phoneNumberInput.addEventListener('input', function () {
    // Allow only digits and '+' at the start
    this.value = this.value.replace(/[^+\d]/g, '');

    // Check if the value is valid
    const valid = /^\+?\d{10,}$/.test(this.value);
    phoneError.style.display = valid ? 'none' : 'block';
  });
}


    document.addEventListener("click", function(event) {
        if (event.target.classList.contains("edit-save")) {
            var firstName = document.querySelector(".personal-info-edit .fname").value;
            var lastName = document.querySelector(".personal-info-edit .lname").value;
            var phone = phoneNumberInput.value;
            var customerId = document.querySelector(".cids").value;
            var email = document.querySelector(".personal-info-edit .emails").value;

            // Only proceed if the phone number is valid
            if (!/^\+?\d{10,}$/.test(phone)) {
                phoneError.textContent = "Enter a valid phone number"; // Update error message
                phoneError.style.display = 'block';
                return; // Stop further execution
            }

            var xhr = new XMLHttpRequest();
            xhr.open("POST", "/apps/ac/customer_update.php", true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) { // Request is complete
                    if (xhr.status === 200) { // Successfully received a response
                        try {
                            var response = JSON.parse(xhr.responseText);

                            // Clear previous error messages
                            phoneError.textContent = '';
                            emailError.textContent = '';

                            // Check for errors in response
                            if (response.errors) {
                                if (response.errors.phone) {
                                    phoneError.textContent = response.errors.phone.join(", ");
                                    phoneError.style.display = 'block';
                                }
                                if (response.errors.email) {
                                    emailError.textContent = "Your email is: " + response.errors.email.join(", ");
                                    emailError.style.display = 'block';
                                }
                            } else if (response.customer) {
                                // Success case
                                var updatedElement = document.querySelector(".address-updated.pre-c");
                                if (updatedElement) {
                                    updatedElement.style.display = "block";
                                }
                            }

                            window.scrollTo(0, 0);
                            document.querySelectorAll(".personal-info-edit input").forEach(function(input) {
                                input.disabled = true;
                            });
                            var saveBtns = document.querySelector(".save-btns");
                            var editFormBtns = document.querySelector(".edit-form-btns");

                            if (saveBtns) saveBtns.style.display = "none";
                            if (editFormBtns) editFormBtns.style.display = "block";

                            setTimeout(function() {
                                var closeIcon = document.querySelector(".pre-c:visible .icon-close");
                                if (closeIcon) closeIcon.click();
                            }, 7000);
                        } catch (error) {
                            console.error("Failed to parse JSON response:", error);
                        }
                    } else {
                        console.error("Request failed with status:", xhr.status);
                    }
                }
            };

            var data = "fn=" + encodeURIComponent(firstName) + 
                       "&ln=" + encodeURIComponent(lastName) + 
                       "&phn=" + encodeURIComponent(phone) + 
                       "&cid=" + encodeURIComponent(customerId) + 
                       "&email=" + encodeURIComponent(email) + 
                       "&formtype=first";
            xhr.send(data);
        }
    });
});


/* Account Update Js */ 

  document.addEventListener("click", function(event) {
    if (event.target.classList.contains("chnged-psw")) {
        var cid = document.querySelector(".cids").value;
        var password = document.querySelector(".main-px").value;

        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/apps/ac/pw_update.php", true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) { // Request is complete
                if (xhr.status === 200) { // Successfully received a response
                    try {
                        var response = JSON.parse(xhr.responseText);

                        if (response.customer !== undefined) {
                            var errorElement = document.querySelector(".address-remove-error.pre-c");
                            var updatedElement = document.querySelector(".address-updated.pre-c");
                           var  updatedPassword = document.querySelector(".password-updated");
                            if (updatedPassword) {
                              // Remove the "hide" class if it exists
                              updatedPassword.classList.remove("hide");
                              
                              // Add the "show-message" class
                              updatedPassword.classList.add("show-message");
                            }
                            if (errorElement) errorElement.style.display = "none";
                            if (updatedElement) updatedElement.style.display = "block";
                         
                           
                        } else {
                            var updatedElement = document.querySelector(".address-updated.pre-c");
                            var errorElement = document.querySelector(".address-remove-error.pre-c");

                            if (errorpassword) updatedElement.style.display = "none";
                            if (updatedElement) updatedElement.style.display = "none";
                            if (errorElement) errorElement.style.display = "block";
                        }

                        // window.scrollTo(0, 0);

                        // setTimeout(function() {
                        //     var closeIcon = document.querySelector(".pre-c:visible .icon-close");
                        //     if (closeIcon) closeIcon.click();
                        // }, 7000);
                    } catch (error) {
                        console.error("Failed to parse JSON response:", error);
                    }
                } else {
                    console.error("Request failed with status:", xhr.status);
                }
            }
        };

        var data = "pass=" + encodeURIComponent(password) + "&cid=" + encodeURIComponent(cid);
        xhr.send(data);
    }
});



// Select all elements with the class 'fa-eye'
const triggerPasswords = document.querySelectorAll(".fa-eye");

const showPassword = (trigger) => {
  trigger.addEventListener("click", () => {
    // Get the previous sibling input element
    const passwordInput = trigger.previousElementSibling;

    // Toggle the input type between 'password' and 'text'
    if (passwordInput.getAttribute("type") === "password") {
      passwordInput.setAttribute("type", "text");
      trigger.classList.remove("fa-eye");
      trigger.classList.add("fa-eye-slash");
    } else {
      passwordInput.setAttribute("type", "password");
      trigger.classList.remove("fa-eye-slash");
      trigger.classList.add("fa-eye");
    }
  });
};

// Loop through all '.fa-eye' elements and attach the event listener
triggerPasswords.forEach((trigger) => {
  showPassword(trigger);
});

document.addEventListener("click", function(event) {
    if (event.target.classList.contains("remove-account")) {
        document.querySelector(".pop-up-content.delete_acc").style.display = "block";
        document.querySelector("#overlay-remove").style.opacity = "0";
        document.querySelector("#overlay-remove").style.display = "block";

        var fadeEffect = setInterval(function () {
            var opacity = parseFloat(document.querySelector("#overlay-remove").style.opacity);
            if (opacity < 1) {
                document.querySelector("#overlay-remove").style.opacity = (opacity + 0.1).toString();
            } else {
                clearInterval(fadeEffect);
            }
        }, 30); // roughly equivalent to 300ms in total
    }
});


/* Faq Page */
  document.addEventListener('DOMContentLoaded', function() {
    const spans = document.querySelectorAll('.faq-page .set > span');
    
    if (spans.length > 0) {
        // Activate the first span by default
        const firstSpan = spans[0];
        firstSpan.classList.add('active');

        const firstContent = firstSpan.nextElementSibling;
        if (firstContent && firstContent.classList.contains('content')) {
            firstContent.classList.add('show'); // Make sure this class is used for showing content
        }

        const firstIcon = firstSpan.querySelector('svg');
        if (firstIcon) {
            firstIcon.classList.remove('faq-icon');
            firstIcon.classList.add('faq-minus');
        }
    }

    spans.forEach(span => {
        span.addEventListener('click', function() {
            const isActive = this.classList.contains('active');
            
            // Reset all spans and icons
            spans.forEach(span => {
                span.classList.remove('active');
                const icon = span.querySelector('svg');
                if (icon) {
                    icon.classList.remove('faq-minus');
                    icon.classList.add('faq-icon');
                }
                const content = span.nextElementSibling;
                if (content && content.classList.contains('content')) {
                    content.classList.remove('show');
                }
            });

            if (!isActive) {
                // Activate the clicked span and show its content
                this.classList.add('active');
                const icon = this.querySelector('svg');
                if (icon) {
                    icon.classList.remove('faq-icon');
                    icon.classList.add('faq-minus');
                }
                const content = this.nextElementSibling;
                if (content && content.classList.contains('content')) {
                    content.classList.add('show');
                }
            }
        });
    });
});


/* Js  for Sitemap page */
document.addEventListener('DOMContentLoaded', function() {
    // Get the current URL
    const url = window.location.href;

    // Define the buttons
    const orderHistoryButton = document.querySelector("button[onclick=\"opentab('tab-2',1)\"]");
    const productSupportButton = document.querySelector("button[onclick=\"opentab('tab-3',2)\"]");
    const accountSettingsButton = document.querySelector("button[onclick=\"opentab('tab-4',3)\"]");

    // Check the URL and trigger the appropriate button
    if (url === 'https://hikecrew.com/account?page=orders') {
        if (orderHistoryButton) {
            orderHistoryButton.click();
        }
    } else if (url === 'https://hikecrew.com/account?page=product-support') {
        if (productSupportButton) {
            productSupportButton.click();
        }
    } else if (url === 'https://hikecrew.com/account?page=account-settings') {
        if (accountSettingsButton) {
            accountSettingsButton.click();
        }
    }
});

// Function to set the same height for all elements with a given selector

/* 10-09-2024 */
function setEqualHeight(selector) {
    var elements = document.querySelectorAll(selector);
    var heights = Array.from(elements).map(function(element) {
        return element.clientHeight; // Get the height of each element
    });
    var maxHeight = Math.max.apply(null, heights); // Find the maximum height
    elements.forEach(function(element) {
        element.style.height = maxHeight + 'px'; // Apply the maximum height
    });
}

function removeEqualHeight(selector) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
        element.style.height = ''; // Remove the height
    });
}

// Function to determine if we are on a mobile view
function isMobileView() {
    return window.innerWidth <= 767; // Adjust the width as per your requirement
}

function handleEqualHeight() {
    if (!isMobileView()) {
        // Set equal height for '.card__heading' elements
        setEqualHeight('.card__content .card__heading');

        // Set equal height for '.variant-swatches' elements
        setEqualHeight('.card__content .variant-swatches');
    } else {
        // Remove equal height for '.card__heading' elements
        removeEqualHeight('.card__content .card__heading');

        // Remove equal height for '.variant-swatches' elements
        removeEqualHeight('.card__content .variant-swatches');
    }
}

// Run initially
handleEqualHeight();

// Add event listener for window resize
window.addEventListener('resize', handleEqualHeight);
/* Close delete account */
document.addEventListener('DOMContentLoaded', function() {
    const cancelButton = document.querySelector('.ac-cancel-add');
    const overlayDiv = document.getElementById('overlay-remove');

    // Add click event listener to the button
    if (cancelButton && overlayDiv) {
        cancelButton.addEventListener('click', function() {
            // Change the style of the overlay div
            overlayDiv.style.opacity = '1';
            overlayDiv.style.display = 'none';
        });
    }
});

/*jbhb*/
document.addEventListener('DOMContentLoaded', function() {
    const passwordInput = document.getElementById('CustomerPassword');

    if (passwordInput) {
        // Set autocomplete to off initially
        passwordInput.setAttribute('autocomplete', 'off');
        
        // Remove the key icon on focus
        passwordInput.addEventListener('focus', function() {
            passwordInput.setAttribute('autocomplete', 'new-password');
        });

        // Optionally, use a timeout to delay setting the attribute
        setTimeout(function() {
            passwordInput.setAttribute('autocomplete', 'off');
        }, 1); // 1ms delay
    }
});

/* Progress Bar   03-10-2024 
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.multicolumn-list');
  if (!slider) {
    console.error('Slider not found');
    return;
  }

  const slides = slider.querySelectorAll('.slider__slide');
  if (slides.length === 0) {
    console.error('No slides found in the slider');
    return;
  }

  const progressBarFill = document.querySelector('.slider-progress-bar__fill');
  if (!progressBarFill) {
    console.error('Progress bar fill element not found');
    return;
  }

  const sliderComponent = slider.closest('.custom-bar-wrap');
  const prevArrow = sliderComponent.querySelector('.slider-button--prev');
  const nextArrow = sliderComponent.querySelector('.slider-button--next');
  
  const sliderCounter = sliderComponent.querySelector('.slider-counter--current'); // Select the counter element
  if (!sliderCounter) {
    console.error('Slider counter not found');
    return;
  }

  if (!prevArrow) {
    console.error('Previous arrow not found');
    return;
  }

  if (!nextArrow) {
    console.error('Next arrow not found');
    return;
  }

  if (nextArrow.hasAttribute('disabled')) {
    nextArrow.removeAttribute('disabled');
  }

  let currentIndex = 0;

  function updateProgressBar() {
    const progress = ((currentIndex + 1) / slides.length) * 100;
    progressBarFill.style.width = `${progress}%`;
  }

  function updateArrows() {
    prevArrow.disabled = currentIndex === 0;
    nextArrow.disabled = currentIndex === slides.length - 1;
  }

  function updateCounter() {
  //  sliderCounter.textContent = currentIndex + 1; // Update counter display
    console.log(`Current slide: ${currentIndex}`); // Log current slide
  }

  function showSlide(index) {
    if (index >= slides.length) {
      currentIndex = slides.length - 1;
    } else if (index < 0) {
      currentIndex = 0;
    } else {
      currentIndex = index;
    }

    updateProgressBar();
    updateArrows();
    updateCounter(); // Update counter when slide changes
  }

  prevArrow.addEventListener('click', function() {
    showSlide(currentIndex - 1);
  });

  nextArrow.addEventListener('click', function() {
    showSlide(currentIndex + 1);
  });

  // Swipe detection
  let startX = 0;
  let endX = 0;

  slider.addEventListener('touchstart', function(event) {
    startX = event.touches[0].clientX;
  });

  slider.addEventListener('touchmove', function(event) {
    endX = event.touches[0].clientX;
  });

  slider.addEventListener('touchend', function() {
    if (startX > endX + 50) {
      // Swiped left
      setTimeout(() => showSlide(currentIndex + 1), 100); // Delay before showing next slide
    } else if (startX < endX - 50) {
      // Swiped right
      setTimeout(() => showSlide(currentIndex - 1), 100); // Delay before showing previous slide
    }
  });

  // Initialize
  showSlide(currentIndex);
});

/* Progress Bar   03-10-2024 */
 document.addEventListener('DOMContentLoaded', function () {
    const dots = document.querySelectorAll('.dot_icon .dot1, .dot_icon .dot2, .dot_icon .dot3, .dot_icon .dot4, .dot_icon .dot5');
    const slides = document.querySelectorAll('.content_slides .content-slider-inner');
    const slidesR = document.querySelector('.content-slider-inner');
const mainContentSliderInner = document.querySelector('.main-content-slider-inner');
   const backButton = document.querySelector('.back_link');
    dots.forEach(dot => {
      dot.addEventListener('click', function () {
        const dotClass = this.className;
      mainContentSliderInner.classList.add('hide');
        backButton.classList.remove('hide');
        slides.forEach(slide => {
          if (slide.classList.contains(dotClass)) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });
      });
    });
    if(backButton != null){
   backButton.addEventListener('click', function () {
     this.classList.add('hide');
      mainContentSliderInner.classList.remove('hide');
     slides.forEach(slide => slide.classList.remove('active'));
    });
    }
  });
